import { put, call, fork, all, takeLatest } from 'redux-saga/effects';
import * as hospitalListBySeviceTypes from '~/store/home/homeTypes';
import {
  apiRequestHostpitalList,
  apiRequestHospitalListByService,
} from '~/store/home/homeApi';


/* hospital list */
function* requestHospitalList() {
  try {
    const response = yield call(apiRequestHostpitalList);
    const { data } = response;
    if (typeof data.error_code === typeof undefined)
      yield put({
        type: hospitalListBySeviceTypes.HOSPITAL_LIST_REQUEST_SUCCESS,
        data,
      });
    else
      yield put({
        type: hospitalListBySeviceTypes.HOSPITAL_LIST_REQUEST_SUCCESS,
        data: [],
      });
  } catch (error) {
    yield put({
      type: hospitalListBySeviceTypes.HOSPITAL_LIST_REQUEST_FAIL,
      error,
    });
  }
}

function* requestHospitalListByService(params) {
  try {
    const response = yield call(apiRequestHospitalListByService, params.id);
    const { data } = response;
    if (typeof data.error_code === typeof undefined)
      yield put({
        type:
          hospitalListBySeviceTypes.REQUEST_HOSPITAL_LIST_BY_SERVICE_SUCCESS,
        data,
      });
    else
      yield put({
        type:
          hospitalListBySeviceTypes.REQUEST_HOSPITAL_LIST_BY_SERVICE_SUCCESS,
        data: [],
      });
    params.callback();
  } catch (error) {
    yield put({
      type: hospitalListBySeviceTypes.REQUEST_HOSPITAL_LIST_BY_SERVICE_FAIL,
      error,
    });
  }
}

function* watchRequestHospitalList() {
  yield takeLatest(
    hospitalListBySeviceTypes.HOSPITAL_LIST_REQUEST,
    requestHospitalList,
  );
}

function* watchRequestHospitalByService() {
  yield takeLatest(
    hospitalListBySeviceTypes.REQUEST_HOSPITAL_LIST_BY_SERVICE,
    requestHospitalListByService,
  );
}

export default function* root() {
  yield all([
    // fork(watchRequestBannerList),
    // fork(watchRequestServiceList),
    // fork(watchRequestNewsInfo),
    fork(watchRequestHospitalList),
    fork(watchRequestHospitalByService),
  ]);
}
